const BOOSTER_COUPON_END_POINT = {
  VALID: "/kiban/api/booster-coupon/check/:code",
} as const

export default BOOSTER_COUPON_END_POINT
